import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {
	AppropriatenessState,
	AppropriatenessStateService
} from "@modules/main/components/stocks/appropriateness-modal/+state/appropriateness.state.service";
import { filter, map } from "rxjs/operators";
import {
	APPROPRIATENESS_APPROPRIATE,
	APPROPRIATENESS_NOT_APPROPRIATE,
	APPROPRIATENESS_NOT_EXPERIENCED,
	APPROPRIATENESS_UNKNOWN
} from "@helpers/constants";

@Injectable({ providedIn: "root" })
export class AppropriatenessFacade {
	private appropriatenessStateService = inject(AppropriatenessStateService);

	private getAppropriatenessState$(): Observable<AppropriatenessState> {
		return this.appropriatenessStateService.getState$().pipe(filter((state) => !!state));
	}

	public setAppropriatenessState(testState: string): void {
		this.appropriatenessStateService.updateState({ status: testState });
	}

	public needsStockTest$(): Observable<boolean> {
		return this.getAppropriatenessState$().pipe(map((val) => val.status === APPROPRIATENESS_UNKNOWN));
	}

	public isStockAppropriate$(): Observable<boolean> {
		return this.getAppropriatenessState$().pipe(map((val) => val.status === APPROPRIATENESS_APPROPRIATE));
	}

	public isStockNotAppropriate$(): Observable<boolean> {
		return this.getAppropriatenessState$().pipe(map((val) => val.status === APPROPRIATENESS_NOT_APPROPRIATE));
	}

	public isStockNotExperienced$(): Observable<boolean> {
		return this.getAppropriatenessState$().pipe(map((val) => val.status === APPROPRIATENESS_NOT_EXPERIENCED));
	}

	public isStockNotAppropriateOrNotExperienced$(): Observable<boolean> {
		return this.getAppropriatenessState$().pipe(
			map(
				(val) =>
					val.status === APPROPRIATENESS_NOT_APPROPRIATE || val.status === APPROPRIATENESS_NOT_EXPERIENCED
			)
		);
	}
}
